export const SORT_ORDER_OPTIONS = [
  {
    key: 'add_desc',
    text: '登録日の新しい順',
  },
  {
    key: 'add_asc',
    text: '登録日の古い順',
  },
  {
    key: 'name_asc',
    text: '50音順（あ→わ）順',
  },
  {
    key: 'name_desc',
    text: '50音順（わ→あ）順',
  },
] as const;

export type SortOrderKey = (typeof SORT_ORDER_OPTIONS)[number]['key'];
